import { RootState } from "@store/rootReducer"

export const selectCompany = (state: RootState) => state.details.company
export const selectEnabledCompanyId = (state: RootState) => state.details.enabledCompanyId
export const selectUpdatedAt = (state: RootState) => state.details.updatedAt
export const selectglWidgetID = (state: RootState) => state.details.glWidgetID
export const selectPrice = (state: RootState) => state.details.price
